import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import toast from 'react-hot-toast';
import { Tab } from '@headlessui/react';
import Modal from '../../components/Modal/Modal';
import FormTextInput from '../../components/Form/FormTextInput';

const SampleEditProductDescriptionModal = ({
                                         open, onClose, editFunction, editIndex, defaultValue, defaultSpecValue
                                     }) => {
    const onCloseButtonClickHandler = () => {
        onClose();
    };

    const [formikInitialValues, setFormikInitialValues] = useState({
        productDescription: defaultValue,
        specDescription: defaultSpecValue
    });

    const validationSchema = Yup.object().shape({
        // productDescription: Yup.string(),
        // specDescription: Yup.string(), // TODO check it with Ed for common logic array and string not the best
    });

    const onSubmitHandler = async (formData) => {
        try {
            const organizedSpecData = formData.specDescription.split(";").filter(item => item.trim() !== "");
            editFunction(editIndex, formData.productDescription, organizedSpecData);
            onCloseButtonClickHandler();
            toast.success('Success');
        } catch(e) {
            toast.error('Something went wrong. Please try again');
        }
    };

    useEffect(() => {
        // Spec value converted into string with ; as a new line indicator
        let newDefaultSpecValue = '';
        for(let i=0; i<defaultSpecValue.length ; i+=1) {
            // eslint-disable-next-line prefer-template
            newDefaultSpecValue += (defaultSpecValue[i] + ';');
        }

        setFormikInitialValues({
            productDescription: defaultValue,
            specDescription: newDefaultSpecValue,
        });
    }, [defaultValue, defaultSpecValue]);

    return (
        <Modal open={open} setOpen={onCloseButtonClickHandler}>
            <div className="px-2">
                <Tab.Group>
                    <Tab.Panels>
                        <Formik
                            enableReinitialize
                            initialValues={formikInitialValues}
                            validationSchema={validationSchema}
                            onSubmit={onSubmitHandler}
                        >
                            {({ errors }) => (
                                <Form className="flex flex-col gap-2 py-4">
                                    <FormTextInput name="productDescription" label='General Description' />
                                    <FormTextInput name="specDescription" label='Spec Description' />
                                    <button
                                        type="submit"
                                    >
                                        Continue
                                    </button>
                                </Form>
                            )}
                        </Formik>
                    </Tab.Panels>
                </Tab.Group>
            </div>
        </Modal>
    );
};

SampleEditProductDescriptionModal.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    editFunction: PropTypes.func.isRequired,
    defaultValue: PropTypes.string.isRequired,
    defaultSpecValue: PropTypes.array.isRequired,
    editIndex: PropTypes.number.isRequired,
};

export default SampleEditProductDescriptionModal;
